import Template00 from "./Template-00"

export default {
    Template00
}
